import constants from "./constants";
import moment from 'moment';

const tokenService = {

    getToken() {
        return window.localStorage.getItem(constants.USER_ACCESS_TOKEN_KEY);
    },
    getRole() {
        return window.localStorage.getItem(constants.ROLE);
    },
    getCurrentRole(){
        return window.localStorage.getItem(constants.CURRENT_ROLE);
    },
    setToken(token, role) {
        window.localStorage.setItem(constants.USER_ACCESS_TOKEN_KEY, token);
        window.localStorage.setItem(constants.ROLE, role);
        this.setCurrentRole(role);
    },
    removeToken() {
        window.localStorage.removeItem(constants.USER_ACCESS_TOKEN_KEY);
        window.localStorage.removeItem(constants.ROLE);
        window.localStorage.removeItem(constants.CURRENT_ROLE);
    },
    setCurrentRole(roles){
      if(roles.indexOf(constants.NATA_ROLE_ADMIN) !== -1) {
        window.localStorage.setItem(constants.CURRENT_ROLE, constants.NATA_ROLE_ADMIN);
      }else if(roles.indexOf(constants.NATA_ROLE_AR) !== -1){
        window.localStorage.setItem(constants.CURRENT_ROLE, constants.NATA_ROLE_AR);
      }else if(roles.indexOf(constants.NATA_ROLE_TA) !== -1){
        window.localStorage.setItem(constants.CURRENT_ROLE, constants.NATA_ROLE_TA);
      }else
        window.localStorage.setItem(constants.CURRENT_ROLE, constants.NATA_ROLE_CM);
    },
    setCookie(cname, cvalue, exDays) {
      var d = new Date();
      d.setTime(d.getTime() + (exDays*24*60*60*1000));
      var expires = "expires="+ d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return false;
    },
    setRememberMeCookie(uid, remId) {
      this.setCookie('rememberMe_'+uid, remId, constants.REMEMBER_ME_FOR_DAYS);
    },
    getRememberMeCookie(uid) {
      return this.getCookie('rememberMe_'+uid);
    },
}

export default tokenService;
